export const environment = {
  production: false,
  enable_test_ui: false,
  base_url: 'https://api.payarc.net/v1',
  googleAnalyticsId: 'G-7XE0XMNLME',
  branding_manifest_ttl_ms: 300000, // 5 minutes
  branding_url: 'https://payarc-merchant-images.s3.amazonaws.com/',
  partnerHubUrl: 'https://partnerhub.payarc.net/login'
};
